'use client';
import type React from 'react';
import { type ReactNode, useState } from 'react';
import { CirclePlus, CircleMinus } from 'lucide-react';

import { cn } from '@skybeam/shared-utils/classnames/cn';

//TODO remove css modules
import styles from './faq.module.css';

interface AccordionItemsProps {
  content: ReactNode;
  contentStyles?: string;
  isOpenByDefault?: boolean;
  title: string;
  titleStyles?: string;
}

interface AccordionProps {
  contentStyles?: string;
  data: AccordionItemsProps[];
  titleStyles?: string;
}

const AccordionItem: React.FC<AccordionItemsProps> = (props) => {
  const {
    content,
    contentStyles,
    isOpenByDefault = false,
    title,
    titleStyles,
  } = props;

  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  const toggleItem = () => setIsOpen((prevState) => !prevState);

  return (
    <div data-test="faq-section-item" className="flex flex-col gap-y-2">
      <button
        type="button"
        data-test="faq-section-toggle-button"
        className="flex justify-between text-left"
        onClick={toggleItem}
      >
        <p
          data-test="faq-section-item-title"
          className={cn(styles.faqAccordionTitle, 'text-white', titleStyles)}
        >
          {title}
        </p>
        <div className="size-[24px]">
          {isOpen ? (
            <CircleMinus
              data-test="faq-section-toggle-icon-minus"
              className={styles.faqAccordionIcon}
            />
          ) : (
            <CirclePlus
              data-test="faq-section-toggle-icon-plus"
              className={styles.faqAccordionIcon}
            />
          )}
        </div>
      </button>
      <div
        data-test="faq-section-item-content"
        className={cn(
          styles.faqAccordionContent,
          'text-[#eaecf0]',
          { [styles.open]: isOpen },
          contentStyles,
        )}
      >
        {content}
      </div>
    </div>
  );
};

export const Accordion: React.FC<AccordionProps> = (props) => {
  const { contentStyles, data, titleStyles } = props;
  return (
    <div data-test="faq-section-items" className="flex flex-col gap-y-8">
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          titleStyles={titleStyles}
          contentStyles={contentStyles}
          title={item.title}
          content={item.content}
          isOpenByDefault={item.isOpenByDefault}
        />
      ))}
    </div>
  );
};
